import authInstance from "../Interceptor/interceptor";

export const addBlockEffect = (formData) => {
  return authInstance.post("/blocks/insert", formData);
};

export const deleteBlockEffect = (id) => {
  return authInstance.delete(`/blocks/deleteblock/${id}`);
};

export const editBlockEffect = (id, formData) => {
  return authInstance.put(`/blocks/updateblock/${formData}`, id);
};
export const ViewBlockEffect = () => {
  return authInstance.get("/Block/list");
};

export const listBlockEffect = (pageNo) => {
  return authInstance.get(
    `/blocks/list?pageNo=${pageNo}&pagesize=10&pagination_required=false`
  );
};

export const listAllBlockEffect = (pageNo) => {
  return authInstance.get(
    `/blocks/list?pageNo=${pageNo}&pagesize=10&pagination_required=true`
  );
};

export const listCommonBlockEffect = () => {
  return authInstance.get("/common/blocks");
};
